<template>
  <div>
    <button
      class="uk-button uk-button-secondary"
      :class="{ 'uk-button-small': size === 'small' }"
      @click.prevent="openOfferModal"
    >
      <span class="uk-margin-small-right uk-icon" uk-icon="icon: file-pdf"></span>Angebot
    </button>
    <modal ref="offerModal" large>
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">Angebot zum Fahrzeug | {{ vehicle.carId }}</h2>
      </div>
      <div class="uk-modal-body" uk-overflow-auto>
        <p class="uk-margin uk-h4">{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.edition }}</p>
        <div class="uk-grid" uk-grid>
          <div class="uk-width-2-5@l" v-if="showImage">
            <img
              v-if="vehicle.images && vehicle.images.length"
              :src="vehicle.images[0]['600']"
              :alt="`${vehicle.make}  ${vehicle.model} ${vehicle.edition}`"
            />
            <img
              class="uk-width-1-1"
              v-else
              src="/img/placeholder.png"
              :alt="`${vehicle.make}  ${vehicle.model} ${vehicle.edition}`"
            />
          </div>
          <div class="uk-width-expand@l">
            <ul class="uk-list">
              <li class="uk-margin-remove">{{ vehicle.firstregdate }}</li>
              <li class="uk-margin-remove">{{ vehicle.truemileage | mileage }}</li>
              <li class="uk-margin-remove">
                {{ vehicle.powerkw }} kW {{ vehicle.powerps }} PS | {{ vehicle.fueltype }}
              </li>
              <li class="uk-margin-remove">{{ vehicle.transmission }}</li>
              <li class="uk-margin-remove">{{ vehicle.color }}</li>
              <li class="uk-margin-remove">
                <span v-if="!vehicle.tax">MwSt. nicht ausweisbar</span>
                <span v-else>inkl. MwSt.</span>
              </li>
            </ul>
            <table class="uk-table uk-table-justify uk-table-small">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th class="uk-text-right uk-text-capitalize">Netto</th>
                  <th class="uk-text-right uk-text-capitalize">Brutto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="mode == 'merchant'">
                  <td class="uk-text-bold">B2B-EK</td>
                  <td class="uk-text-right">{{ vehicle.formatedSalepriceMerchant }} €</td>
                  <td class="uk-text-right">{{ vehicle.formatedSalepriceMerchantGross }} €</td>
                </tr>
                <!--
                <tr v-if="mode == 'merchant'">
                  <td class="uk-text-bold">Aufschlag</td>
                  <td class="uk-text-right">{{ surchargeNet | euro }}</td>
                  <td class="uk-text-right">{{ surchargeGross | euro }}</td>
                </tr>
                -->
                <tr>
                  <td class="uk-text-bold">VK-Preis</td>
                  <td class="uk-text-right">
                    {{ formatPrice(salePriceMerchant + surchargeNet) }} €
                  </td>
                  <td class="uk-text-right">{{ formatPrice(salePriceMerchantGross + surchargeGross) }} €</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="uk-width-1-1 uk-margin-remove">
            <table class="uk-table uk-table-justify uk-table-divider uk-table-small">
              <thead>
                <tr>
                  <th><span class="uk-text-small uk-text-capitalize">&nbsp;</span></th>
                  <th class="uk-text-right uk-width-small">
                    <span class="uk-text-small uk-text-capitalize">Netto</span>
                  </th>
                  <th class="uk-text-right uk-width-small">
                    <span class="uk-text-small uk-text-capitalize">Brutto</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="uk-text-bold uk-text-right" style="vertical-align:middle">
                    Angebots-Preis:
                  </td>
                  <td>
                    <currency-input
                      v-model="offerModalData.offerPriceNet"
                      class="uk-input"
                      :distraction-free="{
                        hideCurrencySymbol: true
                      }"
                      @blur.prevent="calcGross($event.target.value)"
                    ></currency-input>
                  </td>
                  <td>
                    <currency-input
                      v-model="offerModalData.offerPriceGross"
                      class="uk-input"
                      :distraction-free="{
                        hideCurrencySymbol: true
                      }"
                      @blur.prevent="calcNet($event.target.value)"
                    ></currency-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <template v-if="tenant.knumber === 'K10122' && mode == 'merchant'">
          <div class="uk-text-bold uk-margin-small uk-text-primary">ODER</div>
          <div class="uk-text-bold uk-margin-small">Preisaufschlag definieren</div>
          <div class="uk-grid" uk-grid>
            <div class="uk-width-1-1">
              <table class="uk-table uk-table-justify uk-table-divider uk-table-small">
                <thead>
                  <tr>
                    <th>
                      <span class="uk-text-small uk-text-capitalize">Ihr Einkaufspreis (netto)</span>
                    </th>
                    <th class="uk-text-right uk-width-small">
                      <span class="uk-text-small uk-text-capitalize">Ihr Aufschlag (brutto)</span>
                    </th>
                    <th class="uk-text-right uk-width-small">
                      <span class="uk-text-small uk-text-capitalize">Ihr Verkaufspreis (brutto)</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="uk-text-bold">{{ vehicle.formatedSalepriceMerchant }},-</td>
                    <td>
                      <currency-input
                        v-model="offerModalData.offerSurcharge"
                        class="uk-input"
                        :distraction-free="{
                          hideCurrencySymbol: true
                        }"
                        @blur.prevent="calcSurcharge($event.target.value)"
                      ></currency-input>
                    </td>
                    <td>
                      <currency-input
                        v-model="offerModalData.offerPriceGross"
                        class="uk-input"
                        :distraction-free="{
                          hideCurrencySymbol: true
                        }"
                        @blur.prevent="calcNet($event.target.value)"
                      ></currency-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <div class="uk-margin">
          <div class="uk-text-bold">Kundendaten einfügen</div>
        </div>
        <form class="uk-grid-small uk-grid" uk-grid>
          <div class="uk-width-1-1">
            <input class="uk-input" type="text" v-model="offerModalData.company" placeholder="Firma" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.firstname" placeholder="Vorname" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.lastname" placeholder="Nachname" />
          </div>
          <div class="uk-width-1-1">
            <input class="uk-input" type="text" v-model="offerModalData.street" placeholder="Straße" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.zipcode" placeholder="PLZ" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.city" placeholder="Ort" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.email" placeholder="E-Mail" />
          </div>
          <div class="uk-width-1-2@s">
            <input class="uk-input" type="text" v-model="offerModalData.phone" placeholder="Telefon" />
          </div>
          <div class="uk-width-1-2@s">
            <label class="uk-text-small">
              <input
                class="uk-checkbox uk-margin-small-right"
                v-model="offerModalData.sendMail"
                type="checkbox"
              />Angebot per Mail senden
            </label>
          </div>
          <!--
                    <div class="uk-width-1-2@s">
                        <label class="uk-text-small">
                            <input class="uk-checkbox uk-margin-small-right" v-model="offerModalData.isNet" type="checkbox">Netto (Export)
                        </label>
                    </div>
                    -->
        </form>
      </div>
      <div class="uk-modal-footer uk-text-right">
        <div class="uk-inline">
          <label>
            <input type="checkbox" class="uk-checkbox" v-model="offerModalData.isNeutral" />
            Neutrales Angebot
            <span data-uk-icon="icon:info;ratio:0.8" data-uk-tooltip="Ohne Logo und Adressdaten"></span>
          </label>
          <button
            class="uk-button uk-button-primary uk-margin-small-left"
            @click.prevent="sendOffer"
            :disabled="isSending"
          >
            <div v-if="isSending" data-uk-spinner="ratio: 0.7" class="uk-margin-small-right"></div>
            Angebot erstellen
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import { mapGetters } from 'vuex'
import VehicleService from '@/services/vehicle.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import axios from 'axios'

import Configuration from '@/configuration'
const baseURL = Configuration.value('apiFrontend')

export default {
  props: ['vehicle', 'size'],

  data() {
    return {
      offerModalData: {
        isNeutral: false,
        offerPriceGross: 0,
        offerPriceNet: 0,
        offerSurcharge: 0
      },
      isSending: false
    }
  },
  components: {
    Modal
  },

  mounted() {
    const initialOfferPriceGross = this.salePriceMerchantGross + this.surchargeGross
    this.offerModalData.offerPriceGross = initialOfferPriceGross
    this.calcNet(initialOfferPriceGross)
  },

  methods: {
    openOfferModal() {
      this.$refs.offerModal.open()
    },

    calcGross(val) {
      const value = parseFloat(val.toString().replace('.', ''))
      const calc = this.vehicle.tax === false ? value : (value * 1.19).toFixed(2)
      this.offerModalData.offerPriceGross = parseFloat(calc)
    },
    calcNet(val) {
      const value = parseFloat(val.toString().replace('.', ''))
      const calc = (this.offerModalData.offerPriceNet = this.vehicle.tax === false ? value : (value / 1.19).toFixed(2))
      this.offerModalData.offerPriceNet = parseFloat(calc)
    },
    calcSurcharge(val) {
      const value = parseFloat(val.toString().replace('.', ''))
      const calcGross = (parseFloat(this.vehicle.formatedSalepriceMerchantGross.replace('.','')) + value).toFixed(2)
      this.offerModalData.offerPriceGross = parseFloat(calcGross)

      const priceNet = parseFloat(this.vehicle.formatedSalepriceMerchant.replace('.','')) + value
      const calcNet = (this.offerModalData.offerPriceNet =
        this.vehicle.tax === false ? priceNet : (priceNet / 1.19).toFixed(2))
      this.offerModalData.offerPriceNet = parseFloat(calcNet)
    },

    sendOffer() {
      this.isSending = true
      VehicleService.createOffer(Object.assign({}, this.offerModalData, { vehicleId: this.vehicle.carId, showImage: this.showImage }))
        .then(response => {
          this.isSending = false
          this.$refs.offerModal.close()
          this.offerModalData = {
            isNeutral: false,
            offerPriceGross: 0,
            offerPriceNet: 0,
            offerSurcharge: 0
          }
          this.downloadPdf(response.data)
        })
        .catch(() => {
          this.isSending = false
          iziToast.error({
            title: 'Fehler!',
            message: 'Fehler beim erstellen des Angebotes',
            timeout: 5000,
            position: 'topCenter'
          })
        })
    },

    downloadPdf(offer) {
      axios({
        url: `${baseURL}/offer/print/${offer.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${offer.filename}`)
        document.body.appendChild(link)
        link.click()
      })
    },

    formatPrice(value) {
      let val = (value / 1).toFixed().replace('.', ',') //toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },

  watch: {
    /*
    'offerModalData.offerSurcharge': function(val, oldVal) {
      if (val != oldVal && val != '' && val != this.surcharge) {
        this.offerModalData.offerSurcharge = val
        this.offerModalData.offerPriceGross = (
          parseFloat(this.vehicle.salepricemerchantgross) + parseFloat(val)
        ).toFixed()
        this.offerModalData.offerPriceNet = (parseFloat(this.vehicle.salepricemerchant) + parseFloat(val)).toFixed()
      }
    }
    
    'offerModalData.offerPriceGross': function(val, oldVal) {
      if (val != oldVal && val != '' && oldVal != this.offerPriceGross) {
        //this.offerModalData.offerPriceGross = val
        this.offerModalData.offerPriceNet =
          this.vehicle.tax === false ? val : parseFloat(val / 1.19).toFixed()
      }

      //this.offerModalData.offerSurcharge = (parseFloat(val) - parseFloat(this.vehicle.salepricemerchantgross)).toFixed();
    },

    'offerModalData.offerPriceNet': function(val, oldVal) {
      if (val != oldVal && val != '' && oldVal != this.offerPriceNet) {
        //this.offerModalData.offerPriceNet = val
        const calcGross = this.vehicle.tax === false ? val : parseFloat(val * 1.19).toFixed(2);
        if(calcGross !== this.offerModalData.offerPriceGross) {
          this.offerModalData.offerPriceGross = calcGross
        }
      }

      //this.offerModalData.offerSurcharge = parseFloat(val) - parseFloat(this.vehicle.salepricemerchantgross).toFixed();
    }
    */
  },

  computed: {
    ...mapGetters(['mode', 'modePriceLabel', 'showEndcustomerPrices', 'showMerchantPrices', 'tenant', 'merchantConfig']),
    offerPriceNet() {
      return parseFloat(Math.ceil(this.vehicle.salepricemerchant)) + this.surchargeNet
    },

    offerPriceGross() {
      return parseFloat(Math.ceil(this.vehicle.salepricemerchantgross)) + this.surchargeGross
    },

    surchargeNet() {
      return this.vehicle.tax ? this.vehicle.surchargeEndCustomer : this.vehicle.surchargeEndCustomerGross
    },

    surchargeGross() {
      return this.vehicle.surchargeEndCustomerGross
    },
    salePriceMerchantGross() {
      return Math.round(parseFloat(this.vehicle.formatedSalepriceMerchantGross.replace('.','')))
    },
    salePriceMerchant() {
      return Math.round(parseFloat(this.vehicle.formatedSalepriceMerchant.replace('.','')))
    },
    showImage() {
      if(this.mode !== 'merchant' && (this.merchantConfig && this.merchantConfig.general && this.merchantConfig.general.hideImages)) {
        return false
      }

      return true
    },
  }
}
</script>
